import { View } from "@react-pdf/renderer";
import { ResumePDFDescription } from "components/Resume/ResumePDF/common";
import { styles } from "components/Resume/ResumePDF/styles";
import type { ResumeCustom } from "lib/redux/types";
import { TemplateFivePDFSection } from "./common";

export const Custom = ({
  heading,
  custom,
  themeColor,
}: {
  heading: string;
  custom: ResumeCustom;
  themeColor: string;
}) => {
  const { descriptions } = custom;

  return (
    <TemplateFivePDFSection themeColor={themeColor} heading={heading}>
      <View style={{ ...styles.flexCol }} wrap={false}>
        <ResumePDFDescription items={descriptions} />
      </View>
    </TemplateFivePDFSection>
  );
};
